module.exports = __webpack_public_path__ + "media/reference1.e8942edf.mp3";